// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__WUKmx","addWidgetButton":"Header_addWidgetButton__3db8T","dashboardTabs":"Header_dashboardTabs__1_S9A","active":"Header_active__xZe5C"};